//
//
//
//
//
//

import { debounce } from "quasar";
import { mapActions, mapGetters } from "vuex";
import { getQueryForTaskUrl } from "@/components/tasks/appOpenedTaskDetails";
import AppUserTaskDetails from "./app.vue";

export default {
    name: "AppUserTask",
    components: {
        AppUserTaskDetails
    },
    props: {
        taskId: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            firstTrigger: true,
            isActive: false,
            taskParams: {}
        };
    },
    computed: {
        ...mapGetters("userProfile", ["userCookieInfo", "getUserId", "getUserIsManager"])
    },
    watch: {
        taskId(newValue) {
            if (newValue && this.taskParams.taskId && newValue !== this.taskParams.taskId) {
                this.isActive = false;
                this.getTaskDetails();
            }
        }
    },
    created() {
        this.getTaskDetails();
    },
    activated() {
        this.getTaskDetails();
    },
    deactivated() {
        this.isActive = false;
    },
    methods: {
        ...mapActions("tasks", ["getTaskInformation"]),
        ...mapActions("reports", ["getTaskInfoUsingPerspective", "getGuiItemDetails"]),
        getTaskDetails: debounce(function getTaskDetails() {
            const { meta, params, path } = this.$route;
            const { taskId, applicationId, dataViewsId } = params;
            let payload;
            let selectedMethod;
            if (meta.taskType === "dataViews") {
                payload = { taskId, applicationId, dataViewsId };
                selectedMethod = "getTaskInfoUsingPerspective";
            } else {
                payload = { taskId };
                selectedMethod = "getTaskInformation";
            }

            this[selectedMethod](payload).then(
                data => {
                    const isMobile = localStorage.getItem("localIsSmallScreen");
                    const claimedByThisUser = data.claimedBy === this.getUserId;
                    const isExternalTask = this.userCookieInfo.permissions.includes("f:ext");
                    const [, second] = this.$route.path.split("/");
                    let customProps = {};
                    let isReports;

                    if (["dataViews", "analytics"].includes(meta.taskType)) {
                        isReports = true;
                    } else if (["mydashboard-tasks", "myteamsdashboard-tasks"].includes(second)) {
                        const isTeamsDashboard = second === "myteamsdashboard-tasks";
                        customProps = {
                            __fromAdmin: true,
                            __isManager: isTeamsDashboard && this.getUserIsManager,
                            __readonly: isTeamsDashboard,
                            __teamDashboard: isTeamsDashboard,
                            __dashboard: true
                        };
                    } else if (["myTasks-completedTasks", "teamTasks-completedTasks"].includes(second)) {
                        customProps = {
                            __tasksCompleted: true,
                            __teamsTasks: second === "teamTasks-completedTasks",
                            __readonly: true
                        };
                        if (isMobile) {
                            const customValue = customProps.__teamsTasks ? "completedTeamsTasks" : "completedTasks";
                            localStorage.setItem("isCompleted", customValue);
                        }
                    } else if (second === "myTasks-todoTasks") {
                        customProps = {
                            __tasks: true
                        };
                    } else if (second === "teamTasks-todoTasks") {
                        customProps = {
                            __teamsTasks: true,
                            __readonly: true,
                            __isManager: true,
                            __fromAdmin: true
                        };
                    }

                    const readonly = isReports || !!customProps.__readonly;
                    const checkForTeamTask = ["myteamsdashboard-tasks", "teamTasks-todoTasks"].includes(second);
                    const checkForReportsDataViews = ["dataViews", "analytics"].includes(meta.taskType) && !data.active && !data.isEnded;

                    if (checkForReportsDataViews || (!data.active && (checkForTeamTask || (claimedByThisUser && !readonly)))) {
                        this.$router.push("/taskNotAvailable");
                    } else if (readonly || claimedByThisUser || isExternalTask) {
                        if (meta.taskType === "dataViews" && path.includes("instances")) {
                            const payloadForGui = {
                                appId: data.applicationId,
                                instanceId: data.processInstanceId,
                                perspectiveId: dataViewsId,
                                ...data.isEnded ? { endActivityId: data.activityId } : {}

                            };
                            this.getGuiItemDetails(payloadForGui).then(
                                responseGui => {
                                    this.taskParams = { ...getQueryForTaskUrl(data),
                                        ...customProps,
                                        ...(readonly ? { canEscalate: !readonly } : {}),
                                        ...(isReports ? { __reports: true, __readonly: true } : {}),
                                        ...(responseGui?.guiDetails?.id ? { guiId: responseGui?.guiDetails?.id } : {}),
                                        perspectiveId: dataViewsId,
                                        __externalTaskComplete: !!isExternalTask,
                                        isExternalTask };
                                    this.isActive = true;
                                }
                            );
                        } else {
                            this.taskParams = { ...getQueryForTaskUrl(data),
                                ...customProps,
                                ...(readonly ? { canEscalate: !readonly } : {}),
                                ...(isReports ? { __reports: true, __readonly: true } : {}),
                                ...(meta.taskType === "dataViews" ? { perspectiveId: dataViewsId } : {}),
                                __externalTaskComplete: !!isExternalTask,
                                isExternalTask };
                            this.isActive = true;
                        }
                    } else {
                        this.$router.push("/accessDenied");
                    }
                }
            )
                .catch(() => {
                    this.$router.push("/accessDenied");
                });
        }, 600)
    }
};
